module.exports = __webpack_public_path__ + "img/pos_checked0.7b529c21.png";